import React, { lazy, Suspense } from 'react';
import { MapTo } from '@adobe/aem-react-editable-components';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { isHighlightingCardEmpty } from './helpers';
const HighlightingCard = lazy(() => import('./HighlightingCard'));
const highlightingCardEditConfig = {
    emptyLabel: 'Highlighting Card',
    isEmpty: isHighlightingCardEmpty,
};
function HighlightingCardHolder(arg) {
    return (React.createElement(Suspense, { fallback: React.createElement(FlexWrapper, { minHeight: "100px", position: "relative" },
            React.createElement(SpinnerLoader, { isLoading: true, hasBackground: false })) },
        React.createElement(HighlightingCard, { ...arg })));
}
export default MapTo([AEM_FUNCTIONS.highlightingCard])(HighlightingCardHolder, highlightingCardEditConfig);
